import "../../i18n/i18n.config";
import i18next from "../../i18n/i18n.config";
import { useTranslation } from "../../i18n/custom.i18n";


//import { LibRobotsData } from "../../utils/LibRobotsData";
import { LibData as LibAxesData } from "../../utils/LibAxesData";
import { LibData as LibToolsData } from "../../utils/LibToolsData";
import { LibData as LibObjectsData } from "../../utils/LibObjectsData";
import { StationData } from "../../utils/StationData";
import { AddinsData } from "../../utils/AddinsData";
import { PostsData } from "../../utils/PostsData";
import { station_name } from "./description-station-name";

let type = "";
let img = "";
let img_cdn = "";
let name_url = "";
let iframe_url = "";
let preview_3d_enabled = false;
let language = "en";

const setType = (type_string) => type = type_string;
const setImg = (img_string) => img = img_string;
const setImgCdn = (img_string) => img_cdn = img_string;
const setNameUrl = (name_url_string) => name_url = name_url_string;
const setiFrameUrl = (iframe_url_string) => iframe_url = iframe_url_string;
const setPreviewState = (preview_state) => preview_3d_enabled = preview_state;


const item_title = (type: string, item: any, t: any) => {
    let title = "";
    switch(type) {
        case "robot":
            title = item["N"] + " | " + t('library-headers.title-robot');
            break;
        case "tool":
            title = item["N"] + " | " + t('library-headers.title-tool');
            break;
        case "station":
            title = station_name(item, t) + " | " + t('library-headers.title-station');
            break;
        case "addin":
            title = item["N"] + " | " + t('library-headers.title-addins');
            break;
        case "post":
            title = item["N"] + " | " + t('library-headers.title-posts');
            break;
        case "axis":
            title = item["N"] + " | " + t('library-headers.title-axis');
            break;
        case "object":
            title = item["N"] + " | " + t('library-headers.title-object');
            break;
        default:
            title = item["N"] + " | RoboDK";
            break;
    }
    //console.log(item);
    //console.log("Updated title: " + title);
    return title;
}
const item_description = (type: string, item: any, t: any) => {
    let desc = "";
    if (item.hasOwnProperty("desc") && item.hasOwnProperty(window.Languages.language)) {
        desc = item["desc"][window.Languages.language].split("\n")[0];
    } else {
        switch (type) {
            case "tool":
                //desc = "Technical information and 3D model of the " + item["N"] + " tool.";  
                desc = t('meta.tool').replace(/\{name\}/g,item["N"]);
                break;    
            case "station":
                desc = t('meta.station').replace(/\{name\}/g,station_name(item, t));
                break;  
            case "addin":
                desc = t('meta.addin').replace(/\{name\}/g,item["N"]);
                break;    
            case "post":
                desc = t('meta.post').replace(/\{name\}/g,item["N"]);
                break;  
            case "axis":
                desc = t('meta.axis').replace(/\{name\}/g,item["N"]);
                break;  
            //case "object":
            default:
                desc = t('meta.object').replace(/\{name\}/g,item["N"]);
                break;     
        }
        
        // TODO: Add automatic descriptions for stations
        // desc = "Technical information and 3D model of the " + item["N"];
    }
    console.log(item);
    console.log("Updated description: " + desc);
    return desc;
}


const init = () => {
    // TODO: This function seems to redundant with details.tsx::Details() main execution. 
    // For example, init is executed for addins but not for tools?
    // could we unify this behavior and put the title and description in one place?
    const { t, i18n } = useTranslation();
    const item_data = extract_parameter(window.location.search);
    //console.log("item data from utils", item_data);
    
    var temp_iframe_url = "";
    if (window.Paths.ROBODK_WEB_EMBED_CDN){
        // Is this function being used? Where??
        let file_folder = "";
        if (type == "axis"){
            file_folder = "library-robots";
        } else {
            file_folder = "library-" + type + "s";
        }  
        // WTF?? This is messy: // axis was converted to library-axiss!!
        // temp_iframe_url = window.Paths.ROBODK_WEB_EMBED_CDN + "/downloads-library/" + folder + "/" + item_data["F"];        
        temp_iframe_url = window.Paths.ROBODK_WEB_EMBED_CDN + "/downloads-library/" + file_folder + "/" + item_data["F"];
    } else {
        temp_iframe_url = window.Paths.ROBODK_WEB_EMBED;
        switch(type) {
            case "robot":
                temp_iframe_url += "robotlib/lib/" + item_data["F"]; 
                break;
            case "tool":
                temp_iframe_url += "robotlib/tools/" + item_data["F"];
                break;

            case "station":
                temp_iframe_url += "library-stations/lib/" + item_data["F"];
                break;
        }
    }
        
    iframe_url = temp_iframe_url;
    if (item_data) {
        document.title = item_title(type, item_data, t);
        document.querySelector('meta[name="description"]').setAttribute("content", item_description(type, item_data, t));
    };

    return item_data;
};

const extract_parameter = (search_string: string) => {
    const valid_parameters = ["Lang", "robot", "tool", "object", "axis", "station", "example", "app", "addin", "post"];
    
    // full path without options
    //var search_param = (window.Settings.LOCAL_BUILD) ? search_string : window.location.search;
    // TODO: WE USED TO HAVE THE FULL PATH HERE!
    // MAKE THIS MORE ROBUST
    var search_param = (window.Settings.LOCAL_BUILD) ? search_string : window.location.search;
    if (search_param.length < 2){
        // production robot-test/tool/library
        // /robot/ABB/IRB-120  (english)
        // /fr/robot/ABB/IRB-120 (french)
        search_param = window.location.pathname;
    } else {
        // we have an addin
        // library-details/item-details.php?addin=robodk.com.whatever
    }
    //console.log("details search");
    //console.log(search_param);


    let splitted_res = split_parameter_url(search_param, valid_parameters);
    
    if(splitted_res.length == 3) {
        window.Languages.language = splitted_res[2];
    } else if (splitted_res[1] == "" || splitted_res.length == 2) {
        window.Languages.language = "en";
    }

    i18next.changeLanguage(window.Languages.language, (err) => {
        if (err) {
            console.log("something went wrong with language selection for details: " + window.Languages.language, err);
            return;
        }
    });

    if (splitted_res){
        //console.log("Details selection:");
        //console.log(splitted_res);
        let key = splitted_res[0];
        let value = splitted_res[1];
        language = splitted_res[2];

        if (valid_parameters.includes(key) && value != "") {
            type = key;    
            switch (type) {
                case "robot":
                case "robot-test": // added for apache .htaccess testing
                    type = "robot";
                    // Robot details page is created using PHP tools
                    //return retrieve_details("robot", value, LibRobotsData.DATA_ALL);
                    console.log("Robots should not be required at this point");
                    return null;
                    //return retrieve_details("tool", value, LibRobotsData.DATA_ALL);
                    

                case "tool":
                    return retrieve_details("tool", value, LibToolsData.DATA_ALL);
                case "object":
                    return retrieve_details("tool", value, LibObjectsData.DATA_ALL);
                case "axis":
                    return retrieve_details("tool", value, LibAxesData.DATA_ALL);

                case "station":
                case "example":
                    type = "station"; // Important! We should override example to station to properly display details
                    // URL will have example, not station                
                    return retrieve_details("station", value, StationData.DATA_ALL);

                case "addin":
                    return retrieve_details("addin", value, AddinsData.DATA_ALL);

                case "post":
                    // For some reason, production path can't load with out /library-details prepend
                    // if (window.Settings.LOCAL_BUILD)
                    //     img = window.Paths.LIB_ASSETS + "controller-icon.svg";
                    // else
                    //     img = "/library-details/" + window.Paths.LIB_ASSETS + "controller-icon.svg";
                    return retrieve_details("post", value, PostsData.DATA_ALL);
            }
        }
    }

    //let key = "";
    //let value = "";
    //search_string.split("&").map((search_param) => {
    //let splitted_res = split_parameter(search_param, valid_parameters);
        

    console.log("Invalid/unknown parameter: " + search_string);
    return {};
};

const split_parameter = (search_param: string, valid_parameters: Array<string>) => {
    let key = "";
    let value = "";
    
    let splitted_param = search_param.split("=");
    if(splitted_param[0][0] == "?")
        splitted_param[0] = splitted_param[0].substring(1);

    if(valid_parameters.includes(splitted_param[0]) && splitted_param[1] != "") {
        key = splitted_param[0];
        value = splitted_param[1];
    }

    if(splitted_param[0] == "Lang" && splitted_param[1] != "") {
        language = splitted_param[1];
    }

    return [key, value];
};
const split_parameter_url = (search_param: string, valid_parameters: Array<string>) => {
    let key = "";
    let value = "";
    let lang = "en"; // english default

    // NOTE: Old logic, revert in case new logic breaks site
    // for (var i=0; i<valid_parameters.length; i++){
    //     if (search_param.includes(valid_parameters[i])){
    //         key = valid_parameters[i];

    //         // var value_url = (window.location.protocol == "http:") 
    //         //     ? search_param.split("?" + key + "=") 
    //         //     : search_param.split("/" + key + "/");
    //         // if (search_param.includes("?" + key + "=")){
    //         if (search_param.includes(key + "=")){
    //             // library-details/item-details.php?addin=robodk.com.whatever
    //             // TODO: HOW TO SUPPORT LANGUAGE??
    //             var value_url = search_param.split("?" + key + "=");
    //             value = value_url[1].replace("/","-");
    //             console.log("k", key);
    //             console.log("v", value);
    //             return [key, value, lang]
    //         } else if (search_param.includes(valid_parameters[i] + "/")){
    //             // full path with details, no search
    //             // Try to retrieve the language from the URL:
    //             // pathname can be: 
    //             // /robot/ABB/IRB-120  (english)
    //             // /fr/robot/ABB/IRB-120 (french)
    //             key = valid_parameters[i];
    //             var value_url = search_param.split("/" + key + "/");
    //             if (value_url.length > 1){                
    //                 // Try to retrieve the language from the URL:
    //                 // pathname can be: 
    //                 // /robot/ABB/IRB-120  (english)
    //                 // /fr/robot/ABB/IRB-120 (french)
    //                 let lang = "en";
    //                 var lang_list = value_url[0].split("/");
    //                 if (lang_list.length > 0 && lang_list[0].length == 3) {
    //                     // The lang_list split became:
    //                     // 0: /fr
    //                     // 1: "" (if any)
    //                     lang = lang_list[0].slice(1); // remove leading slash
    //                 }
    //                 // 
    //                 // replace robodk.com/robot/ABB/IRB-120 by
    //                 // ABB-IRB-120
    //                 value = value_url[1].replace("/","-");
    //                 return [key, value, lang];
    //             }
    
    //         }
    //     }
    // }
    // return null;
    
    let q_pair = {};
    let ret = [];

    if (window.Settings.LOCAL_BUILD) {        
        search_param.slice(1).split("&").map(
            (pair) => {
                let temp = pair.split("=");
                q_pair[temp[0]] = temp[1];
                return q_pair;
            }
        );

        for(let key in q_pair) {
            if(valid_parameters.includes(key)) {
                switch (key) {
                    case "Lang":
                        ret[2] = q_pair[key];
                        break;

                    default:
                        ret[0] = key;
                        ret[1] = q_pair[key];
                        break;
                }
            }
        }
    } 

    // production logic
    else {
        let search_string = window.location.pathname.split("/");

        if (search_string[1] == "robot" || search_string[1] == "robot-test") {
            if (search_string.length == 4) {
                ret = [
                    search_string[1],
                    search_string.slice(2).join("-"),
                    "en"
                ];
            } else if (search_string.length == 5) {
                ret = [
                    search_string[1],
                    search_string.slice(3).join("-"),
                    search_string[2]
                ];
            }
        } else {
            if (search_string.length == 3) {
                ret = [
                    search_string[1],
                    search_string.slice(2).join("-"),
                    "en"
                ];
            } else if (search_string.length == 4) {
                ret = [
                    search_string[1],
                    search_string.slice(3).join("-"),
                    search_string[2]
                ];
            }
        }
    }

    return ret;
};

// img is exported!
const retrieve_details = (type: string, value: string, data: any) => {
    if (data.hasOwnProperty(value)) {
        let item = data[value];

        name_url = value;

        switch (type) {
            case "robot":
                // Robot details page is created using PHP tools
                console.log("Robots should not be required at this point");
                /*img = (item["MT"] == "R") 
                    ? window.Paths.FOLDER_ROBOTS_IMG + item["I"] 
                    : window.Paths.FOLDER_AXES_IMG + item["I"];
                    */
                break;

            case "tool":
                img = window.FOLDER_TYPE_IMG_MAP[item["MT"]] + item["I"];
                img_cdn = window.FOLDER_TYPE_IMG_MAP_CDN[item["MT"]] + item["I"];
                break;

            case "station":
                img =  window.Paths.FOLDER_STATIONS_IMG + item["I"];
                img_cdn = window.Paths.ROBODK_CDN + window.Paths.FOLDER_STATIONS_IMG_CDN + item["I"];
                break;
            
            case "addin":
                img = (item.hasOwnProperty("I"))
                    ? window.Paths.FOLDER_ADDINS_IMG + item["BN"] + "/" + item["I"]
                    : window.Paths.ADDIN_LIB_ASSETS + "np-icon.png";

                img_cdn = (item.hasOwnProperty("I"))
                    ? window.Paths.ROBODK_CDN + window.Paths.FOLDER_ADDINS_IMG_CDN + item["BN"] + "/" + item["I"]
                    : window.Paths.ADDIN_LIB_ASSETS_CDN + "np-icon.png";
                break;

            case "post":
                img = window.Paths.POST_LIB_ASSETS + "controller-icon.svg";
                img_cdn = window.Paths.POST_LIB_ASSETS_CDN + "controller-icon.svg";
                break;

            default:
                break;
        }

        return item;
    } else {
        return {};
    }
};

const download_item = (data) => {
    switch(type) {
        /*case "robot":
            window.get_lib(false, data["F"], "robot");
            return;
            
        case "addin":
            window.get_lib(false, data["F"], "addin");
            return;

        case "station":
            window.get_lib(false, data["F"], "station");
            return;*/

        case "tool":
            window.get_lib(false, data["F"], data["MT"] == "E" ? "robot" : "tool");
            return;

        default:
            window.get_lib(false, data["F"], type);
            return;
    };
};

const list_same_brand_items = (brand_data) => {
    let library_filter;
    switch(type) {
        case "robot":
            let brand_string = brand_data.split(" ").join("-");
            library_filter = 
                (window.Settings.LOCAL_BUILD)
                ? "http://localhost:3001?Lang=" + window.Languages.language + "#filter?brand=" + brand_string 
                : document.location.origin + "/" + (window.Languages.language == "en" ? "" : window.Languages.language + "/") + "library#filter?brand=" + brand_string;

            window.open(library_filter, "_blank");
            return;

        case "station":
            let brand_list = brand_data.map((brand) => brand.split(" ").join("-"));
            library_filter = 
                (window.Settings.LOCAL_BUILD) 
                ? "http://localhost:3002?Lang=" + window.Languages.language + "#filter?brand=" + brand_list.join("+")
                : document.location.origin + "/" + (window.Languages.language == "en" ? "" : window.Languages.language + "/") + "stations#filter?brand=" + brand_list.join("+");

            window.open(library_filter, "_blank");
            return;
    };
};

const toggle_3d_preview = () => {
    if(preview_3d_enabled) {
        document.getElementById("item-column").classList.add("offset-lg-3");
        document.getElementById("preview-3d-container").style.display = "none";
        preview_3d_enabled = false;
    } else {
        document.getElementById("item-column").classList.remove("offset-lg-3");
        document.getElementById("preview-3d-container").style.display = "block";
        preview_3d_enabled = true;
    }
};

const show_similar_items = (data) => {
    switch(type) {
        case "robot":
            show_similar_robots(data);
            return;

        case "station":
            show_similar_stations(data);
            return;
    }
};

const show_similar_robots = (data) => {
    let res = 
        (window.Settings.LOCAL_BUILD)
        ? "http://localhost:3001?Lang=" + window.Languages.language + "#filter?type=" + data["T"].toLowerCase().replace(/ /g, "-")
        : document.location.origin + "/" + (window.Languages.language == "en" ? "" : window.Languages.language + "/") + "library#filter?type=" + data["T"].toLowerCase().replace(/ /g, "-");

    if ("A" in data)
        res += "&axes=" + data["A"]
    if ("R" in data)
        res += "&reach=" + (data["R"] * 0.7) + "-" + (data["R"] * 1.3) // Similar range
    if ("P" in data)
        res += "&payload=" + (data["P"] * 0.5) + "-" + (data["P"] * 10000) // More payload is better!
    if ("W" in data)
        res += "&weight=" + (data["W"] * 0.5) + "-" + (data["W"] * 2) // Lighter is better!
    if ("E" in data)
        res += "&repeatability=" + 0 + "-" + Math.max(data["E"] + 0.05, (data["E"] * 2)) // More repeatable is better!

    window.open(res, "_blank");
};

const show_similar_stations = (data) => {
    let application_list = data["AP"].map((application) => application.split(" ").join("-"));
    let mechanism_list = [];
    
    let res =
        (window.Settings.LOCAL_BUILD)
        ? "http://localhost:3002?Lang=" + window.Languages.language + "#filter?application=" + application_list.join("+")
        : document.location.origin + "/" + (window.Languages.language == "en" ? "" : window.Languages.language + "/") + "stations#filter?application=" + application_list.join("+");

    const size_range = {
        "Small": [0, 60],
        "Medium": [60, 250],
        "Large": [250, 9e9],
    };
    
    if ("RT" in data)
        mechanism_list = data["RT"].map((mechanism) => mechanism.split(" ").join("-"));

    if(
        "S" in data &&
        data["S"] > size_range["Small"][0] && 
        data["S"] < size_range["Small"][1]
    )
        res += "&size=small";
    else if(
        "S" in data &&
        data["S"] > size_range["Medium"][0] && 
        data["S"] < size_range["Medium"][1]
    )
        res += "&size=medium";
    else if(
        "S" in data &&
        data["S"] > size_range["Large"][0] && 
        data["S"] < size_range["Large"][1]
    )
        res += "&size=large";

    res += "&mechanism_type=" + mechanism_list.join("+");
    window.open(res, "_blank");
}


const parse_text_with_link = (full_text: string) => {
    // Example: "this is [a link](robodk.com) to something"

    const link_text_start = full_text.indexOf("[");
    const link_text_end = full_text.indexOf("]", link_text_start);
    const link_start = full_text.indexOf("(", link_text_end);
    const link_end = full_text.indexOf(")", link_start);
    if (link_text_start < 0 || link_text_end < 0 || link_start < 0 || link_end < 0) {
        return (
            <p>
                {full_text}
            </p>)
    }

    const text_lst = [full_text.slice(0, link_text_start), full_text.slice(link_end + 1)];
    let link = full_text.slice(link_start + 1, link_end);

    const link_text = full_text.slice(link_text_start + 1, link_text_end);

    if (link == "") {
        return (
            <p>
                {text_lst[0] + link_text + text_lst[1]}
            </p>
        )
    }

    return (
        <p>
            {text_lst[0]}
            <a
                href={link}
                target="_blank"
            >
                {link_text}
            </a>
            {text_lst[1]}
        </p>
    )
}
const home_lang = () => {
    if (window.Languages.language == "en"){
        return "/";
    }
    return "/" + window.Languages.language + "/";
}

export {
    type,
    img,
    img_cdn,
    name_url,
    iframe_url,
    preview_3d_enabled,
    language,

    setType,
    setImg,
    setNameUrl,
    setiFrameUrl,
    setPreviewState,

    init,
    extract_parameter,
    download_item,
    list_same_brand_items,
    toggle_3d_preview,
    show_similar_items,

    parse_text_with_link,

    station_name,
    item_title,
    item_description,

    home_lang,
}
